import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "row no-gutters pointerhover" };
const _hoisted_2 = { class: "col-10 mb-1" };
const _hoisted_3 = { class: "strong" };
const _hoisted_4 = { class: "col-2 text-right" };
const _hoisted_5 = {
    key: 0,
    class: "row no-gutters mt-3"
};
const _hoisted_6 = {
    key: 0,
    class: "fc-gray w-100 mb-2"
};
const _hoisted_7 = {
    key: 1,
    class: "font7-responsive mb-3"
};
const _hoisted_8 = { class: "w-100" };
const _hoisted_9 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_opening_times_block = _resolveComponent("opening-times-block");
    const _component_google_maps_navigation_button = _resolveComponent("google-maps-navigation-button");
    return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "mapsStoreCard w-100 p-3 border shadow-sm mb-3",
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleDisplay())),
        ref: "self"
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentLocation.name), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                    src: "/images/icons/account/arrowRightIcon.svg",
                    alt: ">",
                    class: _normalizeClass(["toggleDropdownArrow", _ctx.opened ? 'rotateIcon' : '']),
                    style: { "transition": "all 0.3s ease 0s", "transform": "rotate(0deg)" }
                }, null, 2)
            ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-100 font8-responsive fc-gray mb-3" }, [
            _createElementVNode("img", {
                src: "/images/store_pages/icon/icon_ankaufpartner.svg",
                alt: "Ankaufpartner",
                style: { "height": "16px", "width": "16px" }
            }),
            _createTextVNode(" Offizieller "),
            _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
            _createTextVNode(" -Ankaufpartner ")
        ], -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.currentLocation.street_name) + " " + _toDisplayString(_ctx.currentLocation.street_number), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.currentLocation.zip_code) + " " + _toDisplayString(_ctx.currentLocation.city), 1),
        _renderSlot(_ctx.$slots, "button-pre-opening-times", {}, undefined, true),
        (_ctx.opened)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_opening_times_block, {
                    opening_times: (_b = (_a = _ctx.currentLocation) === null || _a === void 0 ? void 0 : _a.opening_times) !== null && _b !== void 0 ? _b : null
                }, null, 8, ["opening_times"]),
                (_ctx.currentLocation.phone_contact)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Telefonnummer:"))
                    : _createCommentVNode("", true),
                (_ctx.currentLocation.phone_contact)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.currentLocation.phone_contact), 1))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "button", {}, () => [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("a", {
                            href: _ctx.link,
                            title: "Zur Storeseite",
                            class: "buttonBase buttonBlue font7-responsive mr-3 mb-2"
                        }, " Zur Storeseite ", 8, _hoisted_9),
                        _createVNode(_component_google_maps_navigation_button, {
                            class: _normalizeClass('link-gray font7-responsive px-0'),
                            location: _ctx.currentLocation
                        }, null, 8, ["location"])
                    ])
                ], true)
            ]))
            : _createCommentVNode("", true)
    ], 512)), [
        [_vShow, _ctx.visible]
    ]);
}
